/**
 * The hit-again step: a drop is sent again. Sky, like General & Slots.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Repeat } from 'lucide-react';

import { StepCard, Switch } from '@/components/ui';

import type { DropGenPlanDetail } from '../../../../drop-generator.types';
import { InheritedSection } from '../../master/InheritedSection';
import { useSectionSources } from '../../master/section-sources';
import type { ContainerEditor } from '../../state/useContainerEditor';
import { HitAgainStep } from '../hit-again/HitAgainStep';
import { hitAgainSummary } from '../hit-again/hit-again-summary';

interface Props {
  index: number;
  editor: ContainerEditor;
  plan: DropGenPlanDetail;
  containerId: string | null;
}

export const HitAgainCard: FC<Props> = ({ index, editor, plan, containerId }) => {
  const own = useSectionSources().isOwn('verdict');
  return (
    <StepCard
      index={index}
      tone="sky"
      icon={Repeat}
      title="Hit again"
      summary={hitAgainSummary(editor.draft)}
      headerRight={
        <Switch
          checked={editor.draft.hitAgain.enabled}
          disabled={!own}
          onCheckedChange={(enabled) => editor.hitAgainPatch({ enabled })}
          aria-label="Enable hit again"
        />
      }
    >
      <InheritedSection section="verdict">
        <HitAgainStep editor={editor} plan={plan} containerId={containerId} />
      </InheritedSection>
    </StepCard>
  );
};
